<template>
  <el-dialog
    :title="inRegistryIng ? '注册' : '注册成功'"
    :visible="visible"
    width="500px"
    append-to-body
    :close-on-click-modal="false"
    destroy-on-close
    @close="handleClose"
    @open="handleOpen"
  >
    <el-form
      v-if="inRegistryIng"
      ref="registryForm"
      :model="registryForm"
      :rules="registryRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >
      <div class="login-wrap">
        <el-form-item prop="companyName" :error="errMsg.companyName">
          <el-input
            ref="companyName"
            v-model="registryForm.companyName"
            placeholder="请输入公司名称"
            name="companyName"
            type="text"
            autocomplete="on"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item prop="tenantCode" :error="errMsg.tenantCode">
          <el-input
            ref="tenantCode"
            v-model="registryForm.tenantCode"
            placeholder="账号名称，请输入4-10位的字母或数字"
            name="tenantCode"
            type="text"
            autocomplete="on"
          />
        </el-form-item>
        <el-form-item prop="tenantMobile" :error="errMsg.tenantMobile">
          <el-input
            ref="tenantMobile"
            v-model="registryForm.tenantMobile"
            placeholder="请输入手机号码"
            name="tenantMobile"
            type="text"
            autocomplete="on"
          />
        </el-form-item>
        <el-form-item prop="authCode" :error="errMsg.authCode">
          <div class="auth-code">
            <el-input
              ref="authCode"
              v-model="registryForm.authCode"
              placeholder="请输入验证码"
              name="authCode"
              type="text"
              autocomplete="on"
            />
            <el-button
              type="text-primary"
              :disabled="countdown > 0"
              :class="countdown > 0 ? 'disabled-btn' : ''"
              :loading="isVerifyCodeLoading"
              @click.native.prevent="queryAuthCode"
            >
              {{ buttonText }}
            </el-button>
          </div>
        </el-form-item>

        <el-button
          :loading="loading"
          type="primary"
          class="login-btn"
          style="
            width: 100%;
            margin-bottom: 20px;
            height: 2.445em;
            font-size: 1.5em;
          "
          @click.native.prevent="handleRegistry"
        >
          注册
        </el-button>
        <div class="footer">
          <span>已有账号？</span>
          <a
            class="to-login"
            href="https://kj.qizhishangke.com/user/login"
            target="_blank"
            >去登录</a
          >
        </div>
      </div>
    </el-form>
    <div v-else>
      <div class="registry-success">
        <i class="el-icon-circle-check"></i>
        <div>注册成功，等待激活</div>
        <p>旺店通ERP顾问将于一个工作日内与您联系，<br>确认激活账号后将通过短信发送账号密码，请留意！</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'RegisterDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const validateTenantBiz = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司名称'))
      }
      callback()
    }
    const validateTenantCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入账号名称'))
      }
      const reg = /^[a-z][a-z0-9]{3,9}$/
      if (!reg.test(value)) {
        callback(new Error('请输入4-10位的小写字母和数字组合，首字符必须是字母'))
      }
      callback()
    }
    const validateTenantMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      }
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      }
      callback()
    }
    const validateAuthCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      }
      callback()
    }
    return {
      buttonText: '获取验证码',
      countdown: 0,
      registryForm: {
        companyName: '',
        tenantCode: '',
        tenantMobile: '',
        authCode: '',
      },
      errMsg: {
        companyName: '',
        tenantCode: '',
        tenantMobile: '',
        authCode: '',
      },
      registryRules: {
        companyName: [
          { required: true, trigger: 'change', validator: validateTenantBiz },
        ],
        tenantCode: [
          { required: true, trigger: 'change', validator: validateTenantCode },
        ],
        tenantMobile: [
          {
            required: true,
            trigger: 'change',
            validator: validateTenantMobile,
          },
        ],
        authCode: [
          { required: true, trigger: 'change', validator: validateAuthCode },
        ],
      },
      loading: false,
      isVerifyCodeLoading: false,
      inRegistryIng: true,
    }
  },
  methods: {
    handleOpen() {
      this.inRegistryIng = true
    //   this.$nextTick(() => {
    //     if (this.registryForm.companyName === '' && this.$refs.companyName) {
    //       this.$refs.companyName.focus()
    //     } else if (
    //       this.registryForm.tenantCode === '' &&
    //       this.$refs.tenantCode
    //     ) {
    //       this.$refs.tenantCode.focus()
    //     } else if (
    //       this.registryForm.tenantMobile === '' &&
    //       this.$refs.tenantMobile
    //     ) {
    //       this.$refs.tenantMobile.focus()
    //     } else if (this.registryForm.authCode === '' && this.$refs.authCode) {
    //       this.$refs.authCode.focus()
    //     }
    //   })
    },
    queryAuthCode() {
      this.$refs.registryForm.validateField('tenantMobile', async(message) => {
        if (!message) {
          try {
            this.isVerifyCodeLoading = true
            const params = {
              tenantMobile: this.registryForm.tenantMobile.trim(),
            }
            const { code, msg } = await this.$request(
              this.$api.login.queryAuthCode,
              params
            )
            if (code === 200) {
              this.countdown = 120
              this.updateButtonText()

              // 启动定时器，每秒更新倒计时
              setInterval(() => {
                this.countdown--
                this.updateButtonText()
              }, 1000)
              this.$message.success(msg || '验证码发送成功')
            }
            this.isVerifyCodeLoading = false
          } catch (error) {
            console.log(error)
            this.isVerifyCodeLoading = false
          }
        }
      })
    },
    updateButtonText() {
      if (this.countdown > 0) {
        this.buttonText = `${this.countdown} s`
      } else {
        this.buttonText = '获取验证码'
      }
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.handleClearData()
    },
    handleClearData() {
      this.registryForm.companyName = ''
      this.registryForm.tenantCode = ''
      this.registryForm.tenantMobile = ''
      this.registryForm.authCode = ''
      this.errMsg.companyName = ''
      this.errMsg.tenantCode = ''
      this.errMsg.tenantMobile = ''
      this.errMsg.authCode = ''
      this.countdown = 0
      this.buttonText = '获取验证码'
    },
    handleRegistry() {
      this.$refs.registryForm.validate(async(valid) => {
        if (valid) {
          try {
            // eslint-disable-next-line no-unused-vars
            for (const key in this.errMsg) {
              this.errMsg[key] = ''
            }
            this.loading = true
            const { companyName, tenantCode, tenantMobile, authCode } =
              this.registryForm
            const params = {
              companyName: companyName.trim(),
              tenantCode: tenantCode.trim(),
              tenantMobile: tenantMobile.trim(),
              authCode: authCode.trim(),
            }

            if (this.$route.query?.hasOwnProperty('source')) {
              params.source = this.$route.query.source
            }

            const { code, msg } = await this.$request(
              this.$api.login.registry,
              params
            )
            if (code === 200) {
              this.$message.success(msg || '注册成功')
              this.inRegistryIng = false
              this.handleClearData()
            }
            this.loading = false
          } catch (error) {
            console.log(error)
            this.loading = false
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  text-align: center;
  font-size: 13px;
}

.auth-code {
  display: flex;
  justify-content: space-between;

  .el-input {
    width: 62%;
  }

  .el-button {
    width: 35%;
    color: #3b6cff;
    border-color: #83a0f7;
  }

  .disabled-btn {
    color: #909399e6 !important;
    border-color: #dcdfe6 !important;
  }
}

.registry-success {
  text-align: center;
  padding: 20px;

  .el-icon-circle-check {
    font-size: 45px;
    color: #5ed96f;
  }

  div {
    font-size: 28px;
    margin-bottom: 24px;
    margin-top: 24px;
  }
  p {
    margin-bottom: 24px;
  }
}

.login-wrap {
  background-color: #fff;

  ::v-deep .el-input--small .el-input__inner {
    height: 3.142em;
    font-size: 1.077em;
    line-height: 3.142em;
  }
  ::v-deep .el-input--small {
    font-size: 1.083em;
  }
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 2em;
    &.el-tooltip {
      margin-bottom: 3em;
    }
  }
  ::v-deep .el-form-item.is-error {
    border-color: #ff4d4a;
    .el-form-item__error {
      color: #ff4d4a;
    }
  }
  .login-type {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    ::v-deep .el-tabs__nav-wrap::after {
      height: 0;
    }
  }
  .login-btn {
    background: #3b6dff;
    border-color: #3b6dff;
  }
  .nologin-btn {
    background: #b5cffe;
    border-color: #b5cffe;
    cursor: not-allowed;
  }
}

.login-wrap p.error {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #f00;
}

div.no-err {
  border: solid 1px #cccccc;
}

div.err {
  border: solid 1px #f15151;
}

.to-login {
  color: blue;
}
</style>
